var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDivisiones(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.6663 66.6667V50C66.6663 45.5797 68.4223 41.3405 71.5479 38.2149C74.6735 35.0893 78.9127 33.3333 83.333 33.3333H116.666C121.087 33.3333 125.326 35.0893 128.451 38.2149C131.577 41.3405 133.333 45.5797 133.333 50V66.6667M83.333 116.667H116.666M99.9997 100V133.333M33.333 83.3333C33.333 78.9131 35.089 74.6738 38.2146 71.5482C41.3402 68.4226 45.5794 66.6667 49.9997 66.6667H150C154.42 66.6667 158.659 68.4226 161.785 71.5482C164.91 74.6738 166.666 78.9131 166.666 83.3333V150C166.666 154.42 164.91 158.66 161.785 161.785C158.659 164.911 154.42 166.667 150 166.667H49.9997C45.5794 166.667 41.3402 164.911 38.2146 161.785C35.089 158.66 33.333 154.42 33.333 150V83.3333Z",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDivisiones);
export default __webpack_public_path__ + "static/media/Divisiones.1bd580b961680577d0c3a5ede4c4ce87.svg";
export { ForwardRef as ReactComponent };